<template>
  <div class="content publico-alvo">
    <h1><span><i class="fas fa-bell"></i> Público Alvo</span></h1>

    <lista-publico-alvo class="mt-5" />
  </div>
</template>

<script>
import ListaPublicoAlvo from '@/modules/PublicoAlvo/components/ListaPublicoAlvo'

export default {
  name: 'PublicoAlvoView',
  components: { ListaPublicoAlvo },
  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/publico-alvo/${tab}`)
    }
  }
}
</script>
